// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-size: 1rem;
}

.role-modal-form {
  padding: 1rem;
}
.role-modal-form div {
  margin-bottom: 1rem;
}

.buttons {
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;
}
.buttons button {
  margin: 0 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/components/create-role-modal/create-role-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;AACF;AACE;EACE,mBAAA;AACJ;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;AAAF;AAEE;EACE,aAAA;AAAJ","sourcesContent":["h1 {\n  font-size: 1rem;\n}\n\n.role-modal-form {\n  padding: 1rem;\n\n  div {\n    margin-bottom: 1rem;\n  }\n}\n\n.buttons {\n  display: flex;\n  justify-content: center;\n  margin-top: 2.5rem;\n\n  button {\n    margin: 0 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
